// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import AvailabilityController from "./availability_controller"
application.register("availability", AvailabilityController)

import AvailabilityGridController from "./availability_grid_controller"
application.register("availability-grid", AvailabilityGridController)

import BatchInvoiceToggleController from "./batch_invoice_toggle_controller"
application.register("batch-invoice-toggle", BatchInvoiceToggleController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import BookingCalendarController from "./booking_calendar_controller"
application.register("booking-calendar", BookingCalendarController)

import BoundTypeToggleController from "./bound_type_toggle_controller"
application.register("bound-type-toggle", BoundTypeToggleController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CalendarScrollController from "./calendar_scroll_controller"
application.register("calendar-scroll", CalendarScrollController)

import CancellationRulesController from "./cancellation_rules_controller"
application.register("cancellation-rules", CancellationRulesController)

import CharLimitController from "./char_limit_controller"
application.register("char-limit", CharLimitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConfirmDialogController from "./confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)

import ConfirmNameController from "./confirm_name_controller"
application.register("confirm-name", ConfirmNameController)

import ConflictCheckController from "./conflict_check_controller"
application.register("conflict-check", ConflictCheckController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DayPickerController from "./day_picker_controller"
application.register("day-picker", DayPickerController)

import DeliveryModeToggleController from "./delivery_mode_toggle_controller"
application.register("delivery-mode-toggle", DeliveryModeToggleController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DocumentBuilderController from "./document_builder_controller"
application.register("document-builder", DocumentBuilderController)

import DocumentChooserController from "./document_chooser_controller"
application.register("document-chooser", DocumentChooserController)

import DocumentSendModalController from "./document_send_modal_controller"
application.register("document-send-modal", DocumentSendModalController)

import DocumentSendModalTriggerController from "./document_send_modal_trigger_controller"
application.register("document-send-modal-trigger", DocumentSendModalTriggerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EndRecurringFormController from "./end_recurring_form_controller"
application.register("end-recurring-form", EndRecurringFormController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import GfeLineItemsController from "./gfe_line_items_controller"
application.register("gfe-line-items", GfeLineItemsController)

import GfeProviderToggleController from "./gfe_provider_toggle_controller"
application.register("gfe-provider-toggle", GfeProviderToggleController)

import GfeToggleController from "./gfe_toggle_controller"
application.register("gfe-toggle", GfeToggleController)

import GuardianPanelController from "./guardian_panel_controller"
application.register("guardian-panel", GuardianPanelController)

import HoneypotTimingController from "./honeypot_timing_controller"
application.register("honeypot-timing", HoneypotTimingController)

import IdleWatcherController from "./idle_watcher_controller"
application.register("idle-watcher", IdleWatcherController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import InputValidationController from "./input_validation_controller"
application.register("input-validation", InputValidationController)

import IntakePacketSortableController from "./intake_packet_sortable_controller"
application.register("intake-packet-sortable", IntakePacketSortableController)

import IntentGateController from "./intent_gate_controller"
application.register("intent-gate", IntentGateController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import MessageComposerController from "./message_composer_controller"
application.register("message-composer", MessageComposerController)

import MessagesReaderController from "./messages_reader_controller"
application.register("messages-reader", MessagesReaderController)

import MinorDetectorController from "./minor_detector_controller"
application.register("minor-detector", MinorDetectorController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NameCapitalizeController from "./name_capitalize_controller"
application.register("name-capitalize", NameCapitalizeController)

import NpiMaskController from "./npi_mask_controller"
application.register("npi-mask", NpiMaskController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import RecurringSummaryController from "./recurring_summary_controller"
application.register("recurring-summary", RecurringSummaryController)

import RecurringToggleController from "./recurring_toggle_controller"
application.register("recurring-toggle", RecurringToggleController)

import RescheduleFormController from "./reschedule_form_controller"
application.register("reschedule-form", RescheduleFormController)

import RescheduleSlotsController from "./reschedule_slots_controller"
application.register("reschedule-slots", RescheduleSlotsController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import ScrollChainController from "./scroll_chain_controller"
application.register("scroll-chain", ScrollChainController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SpotlightController from "./spotlight_controller"
application.register("spotlight", SpotlightController)

import StickyBarController from "./sticky_bar_controller"
application.register("sticky-bar", StickyBarController)

import StripeCardController from "./stripe_card_controller"
application.register("stripe-card", StripeCardController)

import StripeDisconnectController from "./stripe_disconnect_controller"
application.register("stripe-disconnect", StripeDisconnectController)

import StylePropsController from "./style_props_controller"
application.register("style-props", StylePropsController)

import SubmitGateController from "./submit_gate_controller"
application.register("submit-gate", SubmitGateController)

import SuccessAnimationController from "./success_animation_controller"
application.register("success-animation", SuccessAnimationController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TextEditorController from "./text_editor_controller"
application.register("text-editor", TextEditorController)

import TimePickerController from "./time_picker_controller"
application.register("time-picker", TimePickerController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurnstileWidgetController from "./turnstile_widget_controller"
application.register("turnstile-widget", TurnstileWidgetController)
